import React from "react";
import {Box, CircularProgress, Grid} from "@mui/material";
import {RESPONSE_STATUS} from "../constants";


function Loading(props) {
  const {status} = props


  return (
    <>
      {status === RESPONSE_STATUS.Loading ? (
        <Box sx={{height:'100%',display:"flex",alignItems:"center",justifyContent:"center"}}>
          <CircularProgress color="inherit"/>
        </Box>
      ) : (props.children)}
    </>
  )
};




export default (Loading)

